import React from "react";
import "./styles/Tabbar.scss";
import {connect} from "react-redux";
import {AppState} from "../../RootReducer";
import {GlobalPayload} from "../../contenful/types";
import {CurrencyDefinition, Settings} from "../../http/protocol";
import {Dispatch} from "redux";
import {CashierSection} from "../../payments/PaymentsReducer";
import {showCashier} from "../../payments/DepositActions";
import {t} from "../../i18n";
import {getOnrampCurrency} from "../../selectors/payments-selectors";


type AllProps = PropsFromState & PropsFromDispatch;

export class Tabbar extends React.Component<AllProps> {
    constructor(props: AllProps) {
        super(props);
    }

    render() {
        let props = this.props;
        if(this.props.loading) {
            return (
                <div className={"tabbar-container"}>
                    <ul className={"nav nav-tabs cashier-popup row"}>
                        <Tab
                            onClick={()=>{}}
                            active={false}
                            name={t("global.depositButton")}/>
                        <Tab
                            active={false}
                            onClick={()=>{}}
                            name={t("global.withdrawButton")}/>
                        <Tab
                            active={false}
                            onClick={()=>{}}
                            name={t("global.tipButton")}/>
                    </ul>
                </div>
            );
        }
        return (
            <React.Fragment>
                {
                    <div className={"tabbar-container"}>
                        <ul className={"nav nav-tabs cashier-popup row"}>
                            <Tab
                                active={this.props.activeTab === CashierSection.DEPOSIT}
                                onClick={()=>{
                                    this.props.activeTab !== CashierSection.DEPOSIT && this.props.showDeposit && this.props.showDeposit();
                                }}
                                name={t("global.depositButton")}/>
                            <Tab
                                active={this.props.activeTab === CashierSection.WITHDRAW}
                                onClick={()=>{
                                    this.props.activeTab !== CashierSection.WITHDRAW && this.props.showWithdraw && this.props.showWithdraw();
                                }}
                                name={t("global.withdrawButton")}/>
                            {props.onrampCurrency && (
                                <Tab
                                    active={this.props.activeTab === CashierSection.BUY_CRYPTO}
                                    onClick={()=>{
                                        this.props.activeTab !== CashierSection.BUY_CRYPTO &&  this.props.showBuyCrypto && this.props.showBuyCrypto();
                                    }}
                                    name={t("payments.buy-crypto")}/>
                            )}
                            {props.settings?.tippingEnabled && <Tab
                                active={this.props.activeTab === CashierSection.TIP}
                                onClick={() => {
                                    this.props.activeTab !== CashierSection.TIP && this.props.showTip && this.props.showTip();
                                }}
                                name={t("global.tipButton")}/>}
                        </ul>
                    </div>
                }
            </React.Fragment>
        )
    }
}

interface PropsFromState {
    settings?: Settings;
    activeTab: CashierSection;
    loading? : boolean;
    onrampCurrency?: CurrencyDefinition;
}

const mapStateToProps = (state : AppState,ownProps : AllProps) => {

    return {
        settings: state.settings.settings,
        activeTab : state.payments.cashier.section,
        loading  : ownProps.loading,
        onrampCurrency : getOnrampCurrency(state)
    };
}
interface PropsFromDispatch {
    showDeposit : () => void;
    showWithdraw : () => void;
    showBuyCrypto : () => void;
    showTip : () => void;
}




const mapDispatchToProps = (dispatch : Dispatch) => {


    return {
        showDeposit : () => dispatch(showCashier(true, CashierSection.DEPOSIT)),
        showWithdraw :() =>  dispatch(showCashier(true, CashierSection.WITHDRAW)),
        showBuyCrypto :() =>  dispatch(showCashier(true, CashierSection.BUY_CRYPTO)),
        showTip :() =>  dispatch(showCashier(true, CashierSection.TIP))
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Tabbar as any) as any;


interface PropsTab {
    active: boolean;
    onClick: () => void;
    name: string;
}

const Tab = (props: PropsTab) => {
    return (
        <li onClick={() => props.onClick()} className={props.active ? `nav-item active` : "nav-item"}>
            <span className={props.active ? `nav-link active` : "nav-link"}>{props.name}</span>
        </li>
    )
}